import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { CommonWebService, UserHttpService } from ".";
import { Expense, ExpenseDetail, HttpResponse } from "../interfaces";

@Injectable({
    providedIn: 'root'
})
export class ExpenseServiceHttp {

    constructor(private http: HttpClient, private commmonService: CommonWebService, private userSessionService: UserHttpService) {}

    // ** Manage Expenses **

    // Add manage Expenses
    public addExpense(body: Expense, isEdit: boolean = false): Observable<HttpResponse<number>> {
        const formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('expense_title', body.expense_title);
        formData.append('expense_category', body.expense_category);
        formData.append('expense_description', body.expense_description);
        formData.append('expense_forDate', new Date(body.expense_forDate).toISOString());
        formData.append('expense_receipt', body.expense_receipt ? this.commmonService.getFormattedImageBase64(body.expense_receipt) : '');
        formData.append('amount', body.amount);

        if(isEdit) {
            formData.append("expense_id", body.expense_id ? body.expense_id : '');
        }
        return this.http.post<HttpResponse<number>>('expenses/addExpense/', formData);
    }

    // Get expense list
    public getExpenselist(): Observable<HttpResponse<ExpenseDetail[]>> {
        const formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id)
        return this.http.post<HttpResponse<ExpenseDetail[]>>('expenses/expenseList/', formData);
    }

    //Approve/Reject/ Expense List
    public changeExpenseStatus(id: string, status: string, description: string, sender_id: string): Observable<HttpResponse<any>> {
        const formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('expense_id', id);
        formData.append('approval_status', status);
        formData.append('approval_description', description);
        formData.append('sender_id', sender_id);
        return this.http.post<HttpResponse<any>>('expenses/ApproveExpense/', formData);
    }

    // Paid Expense
    public changeExpenseStatusToPaid(id: string, description: string, sender_id: string): Observable<HttpResponse<any>> {
        const formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('expense_id', id);
        formData.append('paid_description', description);
        formData.append('sender_id', sender_id);
        return this.http.post<HttpResponse<any>>('expenses/paidExpense/', formData);
    }

    //delete expense
    public deleteExpense(id: string): Observable<HttpResponse<any>> {
        const formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('expense_id', id);
        return this.http.post<HttpResponse<any>>('expenses/deleteExpense', formData);
    }

    //edit expense
    public expenseDetail(id: string): Observable<HttpResponse<ExpenseDetail[]>> {
        const formData = new FormData();
        formData.append('user_id', this.userSessionService.getUserInfo.user_id);
        formData.append('usr_role_track_id', this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append('token', this.userSessionService.userToken);
        formData.append('expense_id', id);
        return this.http.post<HttpResponse<ExpenseDetail[]>>("expenses/getExpenseForEdit", formData);
    }
}